import i18n from '@/utils/i18n'
import router from '@/router'

let isMobile={
    CardApp_iOS: function () {
        return navigator.userAgent.match(/CardApp_iOS/i) ? true : false;
    },
    CardApp_Android: function () {
        return navigator.userAgent.match(/CardApp_Android/i) ? true : false;
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows());
    }
}

//h5跳转到app
export function GoApp(GoUrl) {
    if (isMobile.CardApp_iOS()) {
        window.webkit.messageHandlers.cardapp.postMessage(GoUrl);
    } else if (isMobile.CardApp_Android()) {
        window.cardapp.startAppPage(GoUrl);
    } else {
        console.warn('未知平台')
    }
}

//返回登录页
export function GoLoginApp() {
    GoApp('App://com.cardapp.local/hongkongCommon/appLoginPage?returnUrl=http://d.test.cn-cic.com/demo/24Universaljump/LoginSuccess.html')
}

//是否是app内部
export function isApp(){
    if(isMobile.CardApp_iOS() || isMobile.CardApp_Android()){
        return true
    }else{
        return false
    }
}

//是否是IOS
export function isIOS(){
    if(isMobile.CardApp_iOS()){
        return true
    }else{
        return false
    }
}

//拨打电话
export function phoneNum(phone,content=i18n.t('Contact')){
    if(isMobile.CardApp_iOS() || isMobile.CardApp_Android()){
        GoApp('App://com.cardapp.local/common/call?number='+phone+'&message='+content+' '+phone+'&positiveBtnText='+i18n.t('Yes')+'&negativeBtnText='+i18n.t('No'))
    }else{
        console.warn('未知平台，拨打电话失败')
        return false
    }
}

//打开网页
export function openPage(url){
    if(isMobile.CardApp_iOS() || isMobile.CardApp_Android()){
        GoApp(url)
    }else{
        console.warn('未知平台，打开网页失败')
        return false
    }
}

//发送邮件
export function sendEmail(email){
    if(isMobile.CardApp_iOS() || isMobile.CardApp_Android()){
        GoApp('App://com.cardapp.local/common/email?address='+email+'&title=万能跳轉测试&bodyText=万能跳轉测试')
    }else{
        console.warn('未知平台，发送邮件失败')
        return false
    }
}

//判断user agent
export function checkLanguage(){
    let language=''
    if(isMobile.CardApp_iOS()){
        let matchs=navigator.userAgent.match(/Language=./i)
        if(matchs && matchs.length>0){
            language=matchs[0].replace('Language=','')
        }
    }else{
        let matchs=navigator.userAgent.match(/Language=./i)
        if(matchs && matchs.length>0){
            language=matchs[0].replace('Language=','')
        }
    }

    //判断
    return language
}

//暴露h5方法
window["h5messageHandlers"]={
    scanCodeSuccess:function(){
        router.push({path:'/CICCoin/scansuccess'})
    },
    scanCodeError:function(){
        router.push({path:'/CICCoin/scanerror'})
    }
}
window["scanCode"]




// WEBPACK FOOTER //
// ./src/utils/dsbridge.js